import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const usePhieuKeToanExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportPhieuKeToanExcel, exportPhieuKeToanFromApi } = await import('../utils/export-excel');
      if (entity?.slug) {
        await exportPhieuKeToanFromApi({
          entitySlug: entity.slug
        });
        return;
      }

      await exportPhieuKeToanExcel();
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
